<template>
  <div class="group-activation">
      <Header title="活跃度" :show-more="false"/>
      <div class="group-title">
         <span v-for="item in tabList" :class="[{'active': curTab === item.key}]" :key="item.key" @click="changeTab(item.key)">{{item.name}}</span>
      </div>
      <ul class="list">
          <li class="list-item" :class="item.icon" v-for="item in list" :key="item.memberId">
              <p class="info">
                    <span class="main">{{item.name}}</span>
                    <el-popover
                        placement="bottom"
                        :width="40"
                        :teleported="false"
                        trigger="hover"
                        popper-class="group-num-popover">
                        <div class="group-num-info">
                            {{ listCount[item.businessKey] }} 
                        </div>
                        <template #reference>
                            <span class="sub text">{{fmtNum(listCount[item.businessKey])}}<span v-if="listCount[item.businessKey] >= 10000" class="unit">万</span></span>
                        </template>
                    </el-popover>
              </p>
          </li>
      </ul>
      <!-- <no-data style="padding-top: 50px" v-else info="活跃度数据为空哦～" url="no-activation.png"/> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Header from '@/components/home-common-title/index.vue'
import NoData from '@/components/no-data.vue'
import { useStore } from 'vuex'
import { pageJump } from '@/global/location-transfer'
import dayjs from 'dayjs'


const store = useStore();

const curTab = ref('all');

const tabList = ref([
    {
        key: 'all',
        name: '总量'
    },
    {
        key: 'week',
        name: '本周'
    },
    {
        key: 'month',
        name: '本月'
    }
])

const list = ref([
    {
        name: '注册人数',
        icon: 'img-regist',
        num: '0',
        businessKey: 'registerCount'
    },
    {
        name: '课程',
        icon: 'img-course',
        num: '0',
        businessKey: 'studyCoursesCount'
    },
    {
        name: '视频案例',
        icon: 'img-video',
        num: '0',
        businessKey: 'vidoCount'
    },
    {
        name: '协作组',
        icon: 'img-group',
        num: '0',
        businessKey: 'collaborationCount'
    },
    {
        name: '资源',
        icon: 'img-resource',
        num: '0',
        businessKey: 'resourcesCount'
    },
    {
        name: '活动',
        icon: 'img-activity',
        num: '0',
        businessKey: 'activityCount'
    }
]);

const listCount = ref({});


function changeTab(key) {
    curTab.value = key;
    getList();
}

function getList(){
    let params = {};
    if(['month', 'week'].includes(curTab.value)) {
        params = getStartAndEndTime(curTab.value);
    }
    G_transmit('getStatistics', {
        name: 'getStatistics',
        data: {
           ...params,
           type: curTab.value, // 类型
        }
    }).then(res => {
         listCount.value = res.data || {};
    });
}


function getStartAndEndTime(type = 'month') {
    if(type === 'month') {
        let startDate = dayjs().startOf('month').format('YYYY-MM-DD');
        let endDate = dayjs().endOf('month').format('YYYY-MM-DD');
        let startTime = dayjs(getTime(startDate)).valueOf();
        let endTime = dayjs(getTime(endDate, true)).valueOf();
        return {
            startTime: startTime,
            endTime: endTime
        }
    }else { // 本周
        let startDate = dayjs().startOf('week').add(1, 'day').format('YYYY-MM-DD');
        let endDate = dayjs().endOf('week').add(1, 'day').format('YYYY-MM-DD');
        let startTime = dayjs(getTime(startDate)).valueOf();
        let endTime = dayjs(getTime(endDate, true)).valueOf();
        console.log(dayjs(startTime).format('YYYY-MM-DD HH:mm:ss'))
        console.log(dayjs(endTime).format('YYYY-MM-DD HH:mm:ss'))
        return {
            startTime: startTime,
            endTime: endTime
        }
    }
}

function getTime(time, isEnd = false) {
    return isEnd ? `${time} 23:59:59` : `${time} 00:00:00`;
}

function fmtNum(val){
    let nums = val;
    if(nums >= 10000) {
        return (nums / 10000).toFixed(2);
    }
    return nums >= 0 ? `${nums}` : ''
}

onMounted(() => {
    getStartAndEndTime();
    getList()
})

</script>

<style lang="scss">
.group-num-popover {
    min-width: 120px !important;
}
</style>

<style lang="scss" rel="stylesheet/scss" scoped>

.group-num-info {
    text-align: center;
}
.group-title {
    font-size: 14px;
    color: var(--srt-nav-main-color);
    span {
        margin: 23px 6px 25px 0px;
        width: 52px;
        height: 34px;
        line-height: 32px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
    }
    .active {
         font-weight: bold;
         color: var(--home-main-color);
         background: var(--home-color-bg);
         border-radius: 4px;
         border: 1px solid var(--home-main-color);
    }
}
.list{
    display: flex;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    flex-wrap: wrap;
    margin-bottom: -10px;
    .avatar{
        width: 70px;
        height: 70px;
        margin-right: 12px;
    }
    .list-item{
        // float: left;
        display: flex;
        align-items: center;
        width: calc(50% - 5px);
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 13px 13px 13px 20px;
        background: var(--home-color-bg-ligter);

        &:nth-child(2n) {
            margin-right: 0px;
        }
        &.img-course {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-course.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }

        &.img-regist {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-regist.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }

        &.img-video {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-video.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }

        &.img-group {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-group.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }

        &.img-resource {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-resource.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }

        &.img-activity {
            &::before {
                content: '';
                background: url(~@/assets/img/home/img-activity.png) no-repeat;
                width: 22px;
                height: 22px;
                background-size: contain;
                margin-right: 9px;
            }
        }
        
        .info{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            color: var(--color-black);
            flex: calc(100% - 31px) 0 0;
            width: calc(100% - 31px);
            .main{
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 6px;
                font-size: 14px;
                color: #333333;
            }
            .sub{
                font-size: 20px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: var(--srt-color-black);
            }
            .unit {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
            }
        }
    }
}
 
</style>
